import { render, staticRenderFns } from "./StempelkarteBig.vue?vue&type=template&id=3f7e882a&scoped=true"
import script from "./StempelkarteBig.vue?vue&type=script&lang=js"
export * from "./StempelkarteBig.vue?vue&type=script&lang=js"
import style0 from "./StempelkarteBig.vue?vue&type=style&index=0&id=3f7e882a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7e882a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7e882a')) {
      api.createRecord('3f7e882a', component.options)
    } else {
      api.reload('3f7e882a', component.options)
    }
    module.hot.accept("./StempelkarteBig.vue?vue&type=template&id=3f7e882a&scoped=true", function () {
      api.rerender('3f7e882a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/stempelkarte/StempelkarteBig.vue"
export default component.exports